import React, { Component } from 'react'
import Select, { Creatable } from 'react-select'
import { FixedSizeList } from 'react-window'

const height = 35

class MenuList extends Component {
	render() {
		const { options, children, maxHeight, getValue } = this.props
		const [value] = getValue()
		const initialOffset = options.indexOf(value) * height || 0

		return (
			<FixedSizeList
				height={maxHeight || '100px'}
				itemCount={children.length}
				itemSize={height}
				initialScrollOffset={initialOffset}
			>
				{({ index, style }) => <div style={style}>{children[index]}</div>}
			</FixedSizeList>
		)
	}
}

export default (props) =>
	props.creatable ? (
		<Creatable components={{ MenuList }} {...props} />
	) : (
		<Select components={{ MenuList }} {...props} />
	)
